<script>
  import IconButton from './components/IconButton.svelte';
  import ArrowLeft32 from "carbon-icons-svelte/lib/ArrowLeft32";

  export let openedMenu;
  export let menuName;

  // When there's already a menu open, prevent animating open/close.
  let previousOpenedMenu = null;
  let noAnimate;
  $: {
    noAnimate = (previousOpenedMenu !== null && openedMenu !== null);
    previousOpenedMenu = openedMenu;
  }

  let menuOpen;
  $: menuOpen = openedMenu === menuName;

  let aside;

  function closeMenu() {
    if (aside.parentNode.querySelector('div.rail button.selected')) {
      aside.parentNode.querySelector('div.rail button.selected');
    }
    openedMenu = null;
  }
</script>



<aside
  class:open={menuOpen}
  class:no-animate={noAnimate}
  bind:this={aside}
>

  <header>
    <IconButton action={closeMenu}>
      <ArrowLeft32 />
    </IconButton>
    {menuName}
  </header>

  <div>
    <section>
      <slot></slot>
    </section>
  </div>

</aside>



<style>
  aside {
    background-color: #fafafa;
    color: hsla(0, 0%, 100%, .8);

    width: 28em;
    margin-left: -28em;
    visibility: hidden;
    transition:
      margin-left 0.3s ease 0s,
      visibility 0s linear 0.3s,
      z-index 0s linear 0.3s;
    display: flex;
    flex-direction: column;
    z-index: 0;
    box-shadow:
      2px 0 1px -1px rgba(0,0,0,.2),
      1px 0 1px  0   rgba(0,0,0,.14),
      1px 0 3px  0   rgba(0,0,0,.12);
  }

  aside.open {
    visibility: visible;
    margin-left: 0;
    transition:
      margin-left 0.3s ease 0s,
      visibility 0s linear 0s,
      z-index 0s linear 0s;
    z-index: 1;
  }

  aside.no-animate {
    transition: none;
  }

  header {
    background-color: #495864;
    height: 85px;
    padding: 0 1em 0 0.15em;
    display: flex;
    box-shadow:
      0 2px  4px -1px rgba(0,0,0,.2),
      0 4px  5px  0   rgba(0,0,0,.14),
      0 1px 10px  0   rgba(0,0,0,.12);
    align-items: center;
    font-size: 20pt;
    font-weight: 600;
    font-family: 'proximanova', 'Source Sans Pro', sans-serif;
    padding: 0 1em 0 0.25em;
    justify-content: space-between;
  }

  header > :global(button:first-child) {
    margin-right: 12px;
  }

  div {
    overflow: auto;
    flex: 1;
  }

  section {
    padding: 1em;
  }

  section > :global(:first-child) {
    margin-top: 0;
  }

  @media (max-width: 36rem) {
    aside {
      width: 100%;
      margin-left: auto;
      height: 100%;
      opacity: 0;
      transform: translateY(10%);
      transition:
        opacity 0.3s ease 0s,
        transform 0.3s ease 0s,
        visibility 0s linear 0.3s,
        z-index 0s linear 0.3s;
      position: absolute;
    }

    aside.open {
      opacity: 1;
      transform: translateY(0%);
      transition:
        opacity 0.3s ease 0s,
        transform 0.3s ease 0s,
        visibility 0s linear 0s,
        z-index 0s linear 0s;
      z-index: 2;
    }

  }
</style>
